import request from '@/utils/request';


// 主试激活
export function Activation(data) {
  return request({
    url: '/action/activation/index',
    method: 'POST',
    data
  });
}

// 检测账号
export function VerifyAccount(params) {
  return request({
    url: '/action/activation/verifyAccount',
    method: 'GET',
    params
  });
}